import CatalogVoters from "./CatalogVoters";

export default CatalogVoters;